(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/cookies-check-and-info/assets/javascripts/third-party-cookies-ask-again.js') >= 0) return;  svs.modules.push('/components/components/cookies-check-and-info/assets/javascripts/third-party-cookies-ask-again.js'); 
(function(svs) {
  'use strict';

  svs.components.cookies_check_and_info.thirdPartyCookiesAskAgain = (function() {
    function setEvents(el) {
      el.on(
        'click',
        '.js-third-party-cookies-accept',
        svs.components.cookies_check_and_info.thirdPartyCookiesAskAgain
          .onThirdPartyCookiesAccept
      );
      el.on(
        'click',
        '.js-third-party-cookies-keep',
        svs.components.cookies_check_and_info.thirdPartyCookiesAskAgain
          .onThirdPartyCookiesKeep
      );
    }

    function removeEvents(el) {
      el.off(
        'click',
        '.js-third-party-cookies-accept',
        svs.components.cookies_check_and_info.thirdPartyCookiesAskAgain
          .onThirdPartyCookiesAccept
      );
      el.off(
        'click',
        '.js-third-party-cookies-keep',
        svs.components.cookies_check_and_info.thirdPartyCookiesAskAgain
          .onThirdPartyCookiesKeep
      );
    }

    return {
      show: function() {
        var overlayStyle = svs.core.detect.formfactor.mobile()
            ? 'auto'
            : '420px',
          data = {};

        if (
          svs.components.cookies_check_and_info.dataHandler.getThirdPartyCookieAccepted()
        ) {
          data.viewData = {
            thirdPartyCookiesAccepted: true
          };
        } else {
          data.viewData = {
            thirdPartyCookiesAccepted: false
          };
        }
        data.viewData.thirdPartyCookiesSupported =
          svs.components.cookies_check_and_info.data.thirdPartyCookiesSupported;

        var template = svs.components.cookies_check_and_info.templates.third_party_cookies_ask_again(
          data
        );

        svs.components.overlay.show(template, true, {
          overlayStyle: overlayStyle,
          overflow: 'auto',
          className: 'cookie-info-box-overlay'
        });
        setEvents(svs.components.overlay.contentEl());
      },
      onThirdPartyCookiesAccept: function() {
        svs.components.cookies_check_and_info.dataHandler.setThirdPartyCookieAccepted(
          true
        );
        svs.components.cookies_check_and_info.thirdPartyCookiesAskAgain.moveNext();
      },
      onThirdPartyCookiesKeep: function() {
        svs.components.cookies_check_and_info.thirdPartyCookiesAskAgain.moveNext();
      },
      moveNext: function() {
        removeEvents(svs.components.overlay.contentEl());
        svs.components.overlay.hide();
        svs.utils.url.navigate(
          svs.utils.url.makeInternal(
            svs.third_party_cookies_check.data.returnUrl,
            '/'
          )
        );
      }
    };
  })();
})(svs);

 })(window);